module.exports = __webpack_public_path__ + "static/media/paw_prompt.7de187f9.mp3";